var exports = {
  "kL": "xcc377c0b--5a8801--container",
  "VY": "xcc377c0b--5a8801--info-block",
};

module.exports = exports;
